import { useRef, useEffect } from 'react';

export default function useClickOutside(callback, ignoreSelectors = []) {
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ignoreSelectors && ignoreSelectors.length) {
        for (let i = 0; i < ignoreSelectors.length; i += 1) {
          if (e.target.closest(ignoreSelectors[i])) return;
        }
      }

      if (ref.current && !ref.current.contains(e.target)) callback();
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [callback, ignoreSelectors]);

  return ref;
}

// ? How to use
// const ref = useClickOutside(() => {
//    Your custom logic here
// });
//
// return <div ref={ref}>...</div>;
